import api from '@/api';

const state = {
	items: [],
	itemsNeedToRefresh: 0,
	itemNeedsToRefresh: 0,
	updated: 0,
};

const getters = {};

const actions = {
	get: ({ commit }, { refresh = false, updateStore = false, ...params }) => {
		return new Promise((resolve, reject) => {
			const { updated } = state;
			if (!refresh && updated > 0) {
				resolve({ data: { items: state.items } });
			}
			api.jobs
				.get(params)
				.then(response => {
					const { items } = response.data;
					if (updateStore) {
						commit('setItems', { items });
					}
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	post: ({ commit }, params) => {
		return new Promise((resolve, reject) => {
			api.jobs
				.post(params)
				.then(response => {
					commit('setItemsNeedToRefresh');
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
	put: ({ commit }, params) => {
		return new Promise((resolve, reject) => {
			api.jobs
				.put(params)
				.then(response => {
					commit('setItemsNeedToRefresh');
					resolve(response);
				})
				.catch(error => {
					reject(error);
				});
		});
	},
};

const mutations = {
	setItems: (state, { items }) => {
		const now = new Date();
		state.items = items;
		state.updated = now.getTime();
	},
	setItemsNeedToRefresh: state => {
		const now = new Date();
		state.itemsNeedToRefresh = now.getTime();
		state.updated = now.getTime();
	},
	setItemNeedsToRefresh: state => {
		const now = new Date();
		state.itemNeedsToRefresh = now.getTime();
		state.updated = now.getTime();
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
